import PropTypes from 'prop-types';
import React from "react";
import {createStore, bindActionCreators, applyMiddleware} from "redux";
import thunk from "redux-thunk";

import memoize from "./memoize";

// Returns an observer generator with easier to use api:
// createObserver((prevState, newState) => fn, selector)
function bindObserverCreator(store) {
    return function createObserver(onChange, selector = arg => arg) {
        let state = selector(store.getState());
        let handler = () => {
            let nextState = selector(store.getState());
            onChange(state, nextState);
            state = nextState;
        };

        return store.subscribe(handler);
    };
}

export {connect, Provider} from "react-redux";

export function connectActions(selector){
    selector = memoize(selector);
    return WrappedComponent => {
        return class ConnectActions extends React.PureComponent {
            static contextTypes = {
                store: PropTypes.object
            };

            static propTypes = {
                children: PropTypes.element
            };

            getWrappedInstance() {
                return this.component;
            }

            render() {
                let {children, ...props} = this.props;
                let actions = selector(this.context.store.actions);
                return <WrappedComponent
                    ref={c => this.component = c}
                    {...props}
                    {...actions}
                >{children}</WrappedComponent>;
            }
        };
    };
}

// creates a redux store with given optional middlewares
// returns {dispatch, getState, getReducer, replaceReducer, subscribe, actions}
export default function createRedux(reducers, actionCreators, ...middleware) {
    middleware = [thunk, ...middleware];

    const storeCreator = applyMiddleware(...middleware)(createStore);
    const store = storeCreator(reducers);
    const actions = {actions: bindActionCreators(actionCreators, store.dispatch)};

    return {...store, ...actions, observe: bindObserverCreator(store)};
}


// WEBPACK FOOTER //
// ./src/lib/createRedux.js